// extracted by mini-css-extract-plugin
export default {"form":"PermissionForm_form__y+A7a"};